const err404 = () => import(/* webpackChunkName: "err404" */ '../views/err-page/404.vue')
const authority = () => import(/* webpackChunkName: "err404" */ '../views/err-page/authority.vue')
const expired = () => import(/* webpackChunkName: "err404" */ '../views/err-page/expired.vue')
export default [
  {
    path: '/404',
    name: 'error_404',
    meta: {
      name: '404',
      keepAlive: false
    },
    component: err404
  },
  {
    path: '/authority',
    name: 'authority',
    meta: {
      name: '暂无权限',
      keepAlive: false
    },
    component: authority
  },
  {
    path: '/expired',
    name: 'expired',
    meta: {
      name: '套餐过期',
      keepAlive: false
    },
    component: expired
  }
]
